import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Slider from 'react-slick';
import { connect } from 'react-redux';
import properties from '../../../../modules/ajio-util/properties';
import {
  luxeGtmProductClick,
  luxeGtmProductImpressions,
  getStoreName,
  segmentEventPush,
  appendItmSourceToURL
} from '../../../../modules/ga/GTMdatalayer';
import * as actions from '../../../../actions/productData';

import { isCatalogNameInFirebaseStore } from '../../../../utils/common';
import {
  getPriceRevealV2WebFeatureFlag,
  getPriceRevealWebData,
  getPriceRevealLUXEFlag,
  getLuxeFlags
} from '../../../../Flags/selectors';
import PriceRevealPLP from '../../../common/ListingPage/priceRevealPLP/PriceRevealPLP';
import { getIsPriceRevealPDP, getShowPriceRevealOnSimilar } from '../../../../utils/pdp';
import { addCustomerType } from '../../../../utils/products';
import { redirect } from '../../../../refresh/utils/cartUtils';
import luxeScreen from '../../../../refresh/constants/luxeScreenType';
import { getCurrentStore } from '../../../../refresh/selectors/metaData';
import { getStoresForHidingMRP, getGiftWithProductEnable, getGiftWithProductConfig, getEnableComingSoonProducts } from '../../../../refresh/selectors/featureFlagsSelector';
import { displayValueWithSymbol } from '../../../../utils/price';
import { getTagValueFromTagEngine, getPriceLableFromTagEngine } from '../../../../utils/product';
import luxeList from '../../../../refresh/constants/luxeScreenType';
import { getVariant } from '../../../../refresh/organism/ABFeature/Feature';
import { readCookie } from '../../../common/Cookie';
import { catalogIdToStoreName } from '../../../../utils';
import { replaceWithJioCDN } from '../../../../../src/utils/imageHandling';
// import Image from 'src/refresh/atoms/ImageView'
// import Image from '../../../../refresh/atoms/ImageView'
import FallbackableImage from '../../../../refresh/molecules/FallbackableImage'

let ajioUrl = properties.getProperty('parentUrl');
const luxeUrl = properties.getProperty('luxeURL');
const streetURL = properties.getProperty('streetURL');

class RecentlyViewed extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialIndex: 4,
      previousIndex: 0,
      hasObserverBlockCall: false
    };
    this.recentlyViewedBlockRef = React.createRef();
    this.hasFired = false;
  }

  openModal(prodData, e) {
    if (e) e.preventDefault();
    this.props.openModal(prodData);
  }

  componentDidUpdate(prevProps, prevState) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !this.hasFired) {
          this.hasFired = true;
          this.handleObserver();

          segmentEventPush({
            event: 'Widget Viewed',
            widget_id: 'recently_viewed',
            widget_name: 'Recently Viewed',
            widget_position: '',
            widget_type: 'Recently Viewed Widget'
          });

        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      }
    );
    if (this.recentlyViewedBlockRef.current) observer.observe(this.recentlyViewedBlockRef.current);
  }

  handleObserver = () => {
    const { product = [] , parentProduct} = this.props;
    if (product && product.length) this.productImpressionsEventPush(parentProduct, product.slice(0, 4));
  };

  productImpressionsEventPush = (parentProduct, product) => {
    const { newDesignLuxe, isNewProductTag, currentStore, enableGiftWithProduct } = this.props;
    const { pdp: { screenType = '', screenName = '' } = {} } = luxeScreen;
    const catalogNames = [];
    let impressions = product?.map((data, index) => {
      const {
        name: description,
        brand,
        code = '',
        price: { value: priceValue = '' },
        fnlColorVariantData: {
          colorGroup: productColor = '',
          exclusiveTill: isExclusive = '',
          productTag = ''
        } = {},
        brickCategory: productCategory = '',
        brickName,
        discount = '',
        tags: { categoryTags = [] } = {},
        catalogName = '',
        segmentId = '',
        experimentId = '',
        offerPrice = {}
      } = data;

      const { giftAvailable = false } = offerPrice;
      catalogNames.push(catalogName);
      const productId = code && code.length > 9 ? code.substring(0, 9) : code;
      const tag = isExclusive ? 'Exclusive' : productTag;
      const productTagEngineValue = getTagValueFromTagEngine(categoryTags);
      const productPriceLabel = getPriceLableFromTagEngine(categoryTags);
      const dimension60Data =
        Number(segmentId) || Number(experimentId) ? `${segmentId}|${experimentId}` : '';
      return {
        name: description,
        id: fnlColorVariantData?.colorGroup,
        price: priceValue,
        brand,
        category: productCategory,
        list: 'pdp screen - recently viewed widget', // example only,
        position: index,
        dimension6: description, // pass value for product_name
        dimension7: productId, // pass value for product_id
        dimension8: brand, // pass value for product_brand
        dimension9: priceValue, // pass value for product_price
        dimension10: productColor, // pass value for product_color
        dimension11: '', // pass value for product_size
        dimension12: '', // pass value for product_trade_discount
        dimension13: productCategory, // pass value for product_category
        dimension14: brickName, // pass value for product_brick
        dimension15: tag, // pass value for product_tag
        dimension16: currentStore, // pass value for Store_type
        dimension23: catalogIdToStoreName(catalogName),
        dimension89: getVariant('enable_urgency_driver_pdp') ? productTagEngineValue : '',
        dimension60: dimension60Data,
        dimension90: getVariant('enable_urgency_driver_pdp') ? productPriceLabel : '',
        dimension91: '',
        dimension82: enableGiftWithProduct && giftAvailable ? 'GetFreebies' : ''
      };
    });
    luxeGtmProductImpressions({
      impressions,
      list: 'pdp screen',
      store_type: 'AJIO',
      page_name: screenName,
      page_type: screenType,
      contains_luxe: true,
      ProductArray: impressions,
      parentProduct: parentProduct
    });
  };

  onNextClick = index => {
    const { product, parentProduct } = this.props;
    const { initialIndex, previousIndex } = this.state;
    if (index + 1 > initialIndex) {
      this.setState({ initialIndex: initialIndex + 4, previousIndex: previousIndex + 4 });
      this.productImpressionsEventPush(
        parentProduct,
        product.slice(previousIndex + 4, initialIndex + 4)
      );
    } else if (index > previousIndex && previousIndex + 4 < product.length) {
      // Last page: slick clamped scroll, fire only unseen products from nextBatchStart
      this.setState({ initialIndex: product.length, previousIndex: previousIndex + 4 });
      this.productImpressionsEventPush(
        parentProduct,
        product.slice(previousIndex + 4, product.length)
      );
    }
  };

  render() {
    const {
      product = {},
      metaData = {},
      recentlyViewed,
      recentlyViewedList,
      priceRevealV2WebFeatureFlag,
      priceRevealV2WebData = {},
      store,
      priceRevealLUXEFlag,
      newDesignLuxe,
      luxeEventPush,
      currentStore,
      isNewProductTag,
      storesForHidingMRP,
      enableGiftWithProduct,
      giftWithProductConfig,
      comingSoonFlag = false,
      parentProduct = {},
    } = this.props;
    const { priceRevealMetaInfo } = recentlyViewed || {};
    const { saleStartTime, saleEndTime } = priceRevealMetaInfo || {};
    const isPriceReveal = getIsPriceRevealPDP(
      priceRevealV2WebFeatureFlag,
      priceRevealV2WebData,
      priceRevealMetaInfo,
      store,
      priceRevealLUXEFlag
    );
    const isPriceRevealPDP = getShowPriceRevealOnSimilar(saleStartTime, saleEndTime);
    const data = Object.keys(product).length === 0 ? '' : product;
    if (Object.keys(data).length === 0) {
      return null;
    }

    const withoutComingSoonProducts = comingSoonFlag
      ? data.filter(
          el => (el?.fnlColorVariantData?.productTag ?? '').toLowerCase() !== 'coming soon'
        )
      : data;

    if (!data?.length) {
      return null;
    }

    return (     
      <div className="comp-section recently-viewed" ref={this.recentlyViewedBlockRef} onClick={
        e=>{
          segmentEventPush({
            event: 'Widget Clicked',
            widget_id: 'recently_viewed',
            widget_name: 'Recently Viewed',
            widget_position: '',
            widget_type: 'Recently Viewed Widget'
          });
        }
      }
      role='group'
      aria-labelledby='recently-viewed-header'
      >
        <h3 className="align-center" role="heading" aria-level="2">
          <span id="recently-viewed-header">
            <strong>Recently Viewed</strong>
          </span>
        </h3>
        <DataList
          storesForHidingMRP={storesForHidingMRP}
          data={withoutComingSoonProducts}
          openModal={this.openModal.bind(this)}
          metaData={metaData}
          isPriceReveal={isPriceReveal}
          isPriceRevealPDP={isPriceRevealPDP}
          luxeEventPush={luxeEventPush}
          newDesignLuxe={newDesignLuxe}
          currentStore={currentStore}
          onNextClick={this.onNextClick}
          isNewProductTag={isNewProductTag}
          recentlyViewedList={recentlyViewedList}
          enableGiftWithProduct={enableGiftWithProduct}
          giftWithProductConfig={giftWithProductConfig}
        />
      </div>
    );
  }
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  let arrow = 'block';
  if (props.slideCount <= 4) {
    arrow = 'none';
  }
  return (
    <div className={className} style={{ display: arrow, textAlign: 'center' }} onClick={onClick} />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  let arrow = 'block';
  if (props.slideCount <= 4) {
    arrow = 'none';
  }
  return (
    <div className={className} style={{ display: arrow, textAlign: 'center' }} onClick={onClick} />
  );
}

class DataList extends React.Component {
  render() {
    const isPdpPage = window.location.href.includes('/p/');
    let { pdp: { screenType = '', screenName = '' } = {} } = luxeScreen;
    if (!isPdpPage) {
      screenType = luxeScreen.plp.screenType;
      screenName = luxeScreen.plp.screenName;
    }
    const {
      pdpList: { recentlyList = '' }
    } = luxeList;
    let {
      metaData: { sis = false, name = '' } = {},
      isPriceReveal,
      isPriceRevealPDP,
      newDesignLuxe,
      luxeEventPush,
      currentStore,
      onNextClick,
      isNewProductTag,
      recentlyViewedList = [],
      storesForHidingMRP,
      enableGiftWithProduct,
      giftWithProductConfig
    } = this.props;


    let RecentlyViewed = null;
    let addClass = '';
    let slickSettings = {
      dots: false,
      arrows: true,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 5000,
      swipe: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      lazyLoad: true,
      lazyLoadOffset: 1,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      afterChange: onNextClick
    };
    if (this.props.data.length < 4) {
      addClass = 'small-centered columns recently-viewed';
    }

    var dataListItems = this.props.data.map((data, index) => {
      let image;
      data.images.map((img, i) => {
        if (img.format === 'productGrid3ListingImage') {
          image = img.url;
        }
      });
      let {
        colorGroup,
        exclusiveTill = '',
        productTag = '',
        brandName = ''
      } = data.fnlColorVariantData;
      let { tags: { categoryTags = [] } = {} } = data;
      const productTagValue = exclusiveTill ? 'EXCLUSIVE' : productTag;
      const productTagEngineValue = getTagValueFromTagEngine(categoryTags);
      const productPriceLabel = getPriceLableFromTagEngine(categoryTags);
      const { offerPrice = {}, catalogName } = data;
      const { displayformattedValue = '', priceReveal = {}, value: offerValue = '', giftAvailable = false } = offerPrice;
      const recentlyViewedItemIndex = recentlyViewedList?.findIndex(el => el.id == colorGroup);
      const storeForRedirect =
        recentlyViewedItemIndex > -1 ? recentlyViewedList[recentlyViewedItemIndex].store : 0;
      const urlForRedirect =
        storeForRedirect == 2 ? streetURL : storeForRedirect == 1 ? luxeUrl : ajioUrl;
      const pdpUrl = appendItmSourceToURL(urlForRedirect + addCustomerType(data.url), {
        itm_source: 'widget',
        itm_source_detail: 'Recently Viewed'
      });
      const redirectFn = redirect(pdpUrl);
      const hideMRP = isCatalogNameInFirebaseStore(storesForHidingMRP, catalogName);
      const { name = '' } = data;

      return (
        <Col key={index} className={addClass}>
          <a
            // href={addCustomerType(data.url)}
            className="prod-sec"
            target="_self"
            rel=""
            href="#"
            onClick={e => {
              e.preventDefault();
              redirectFn();
              luxeEventPush({
                eventName: 'widget_clicks',
                event_category: 'widget interactions',
                event_action: 'widget clicks',
                event_label: 'recently viewed widget',
                product_name: data.name,
                product_id:
                  data.code && data.code.length > 9 ? data.code.substring(0, 9) : data.code,
                product_brand: data.fnlColorVariantData.brandName,
                product_price: data.wasPriceData.displayformattedValue,
                product_color: data.fnlColorVariantData.colorGroup
                  ? data.fnlColorVariantData.colorGroup.split('_')[1]
                  : '',
                product_size: '',
                product_trade_discount: data.discountPercent,
                product_catogory: data.brickCategory,
                product_brick: data.brickName,
                product_tag: isNewProductTag ? productTagEngineValue : productTagValue
              });
              luxeGtmProductClick({
                name: data.name,
                id: data?.fnlColorVariantData?.colorGroup || data?.colorGroup,
                price: data.wasPriceData.displayformattedValue,
                brand: data.fnlColorVariantData.brandName,
                position: index,
                category: data.brickCategory,
                product_size: '',
                product_color: data.fnlColorVariantData.colorGroup
                  ? data.fnlColorVariantData.colorGroup.split('_')[1]
                  : '',
                product_trade_discount: data.discountPercent,
                product_brick: data.brickName,
                product_tag: isNewProductTag ? productTagEngineValue : productTagValue,
                list: recentlyList,
                store_type: currentStore,
                pageType: screenType,
                pageName: screenName,
                sourceStore: catalogIdToStoreName(catalogName),
                containsLuxe: true,
                productPriceLabel: getVariant('enable_urgency_driver_pdp') ? productPriceLabel : '',
                productTagEngineValue: getVariant('enable_urgency_driver_pdp')
                  ? productTagEngineValue
                  : '',
                catalog: catalogName,
                segmentId: data.segmentId,
                experimentId: data.experimentId,
                offerName: enableGiftWithProduct && giftAvailable ? 'GetFreebies' : ''
              });
              window.location.href = pdpUrl;
            }}
            aria-label={`Product image of ${data?.fnlColorVariantData.brandName}, ${data?.name}, MRP ${displayValueWithSymbol(data?.price?.displayformattedValue)}${data?.wasPriceData?.value > data?.price?.value && hideMRP ? `; ${displayValueWithSymbol(data?.wasPriceData?.displayformattedValue)} strike off; available at ${data?.discountPercent}` : ''}. ${priceReveal.bestPrice ? 'Sale Price '+ (priceReveal.bestPrice != -1 ? priceReveal.bestPrice : 'coming soon') : ''}`}     
          >
            <div className="sec-prod-disp">
              <FallbackableImage
                className="sec-img"
                id='sdfsd'
                src={`${replaceWithJioCDN(image)}`}
                alt={`Product image of ${brandName} ${name}`}
                width="204px"
                height="256px"
              />

              {isNewProductTag && productTagEngineValue ? (
                <div
                  className={
                    newDesignLuxe ? 'luxe-sec-prod-exclusive-new' : 'sec-prod-exclusive-new'
                  }
                >
                  {productTagEngineValue}
                </div>
              ) : productTagValue && productTagValue.toLowerCase() !== 'coming soon' ? (
                <div className="sec-prod-exclusive">
                  {productTagValue}
                </div>
              ) : (
                ''
              )}
              {data.fnlColorVariantData.allPromotions ? <div className="sec-prod-offer" /> : ''}

              <div
                id="quickview"
                className="prod-quickview"
                role="button"
                tabIndex={0}
                onClick={e => {
                  e.stopPropagation();
                  this.props.openModal(colorGroup);
                }}
              >
                <span>QUICK VIEW</span>
              </div>
            </div>

            <div className="sec-product-details">
              <div className="sec-prod-title">
                <strong>{data.fnlColorVariantData.brandName}</strong>
              </div>
              <div className="sec-prod-subtitle">
                {data.name}
              </div>
              {data.price && data.price.displayformattedValue ? (
                <div className="sec-prod-cp">
                  {displayValueWithSymbol(data.price.displayformattedValue)}
                </div>
              ) : (
                ''
              )}

              {data.wasPriceData &&
              data.wasPriceData.value &&
              data.wasPriceData.value > data.price.value &&
              hideMRP ? (
                <div className="sec-prod-price">
                  <span className="sec-prod-sp">
                    <span>{displayValueWithSymbol(data.wasPriceData.displayformattedValue)}</span>
                  </span>
                  &nbsp;
                  <span className="discount-percent">&nbsp;({data.discountPercent})</span>
                </div>
              ) : (
                ''
              )}
              {/* Add GWP Here for product widget for Desktop */}
              {enableGiftWithProduct && giftAvailable &&
                <div className='gwp-container'>
                  <span className={newDesignLuxe ? 'gwp-text-luxe' : 'gwp-text'}>{giftWithProductConfig.productWidgetTitle}</span>
                </div>
              }
              {isPriceReveal && (
                <PriceRevealPLP
                  priceRevealClass="pr-pdp-desktop"
                  isPriceRevealPDP={isPriceRevealPDP}
                  priceReveal={priceReveal}
                  orignalPrice={data.price.value}
                  offerValue={offerValue}
                  deviceType="desktop"
                  pageType={isPdpPage ? 'pdp' : ''}
                  luxe={newDesignLuxe}
                  hasLineBreak={!!(newDesignLuxe && isPdpPage)}
                />
              )}
            </div>
          </a>
        </Col>
      );
    });

    if (this.props.data.length > 3) {
      RecentlyViewed = (
        <Slider {...slickSettings} ref="slick">
          {dataListItems}
        </Slider>
      );
    } else {
      RecentlyViewed = <Row className="center">{dataListItems}</Row>;
    }

    return RecentlyViewed;
  }
}

const mapStateToProps = (state, ownProps) => {
  const { flags = {}, metaData = {} } = state;
  const { sis, name } = metaData;
  const storeName = getCurrentStore(state);
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  return {
    product: state.product.recentlyViewed.products,
    recentlyViewed: state.product.recentlyViewed,
    metaData: state.metaData,
    priceRevealV2WebFeatureFlag: getPriceRevealV2WebFeatureFlag(flags),
    priceRevealV2WebData: getPriceRevealWebData(flags),
    store: sis ? name : 'AJIO',
    priceRevealLUXEFlag: getPriceRevealLUXEFlag(flags),
    currentStore: storeName,
    newDesignLuxe,
    recentlyViewedList: ownProps.recentlyViewedList,
    storesForHidingMRP: getStoresForHidingMRP(state),
    enableGiftWithProduct: getGiftWithProductEnable(flags),
    giftWithProductConfig: getGiftWithProductConfig(state),
    comingSoonFlag: getEnableComingSoonProducts(state?.flags),
    parentProduct : state?.product,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  const productIds = ownProps.productIds;
  return {
    fetchData: setTimeout(function() {
      dispatch(actions.getRecentlyViewed(productIds));
    }, 500),
    openModal: productId => dispatch(actions.openModal(productId))
  };
};

export default RecentlyViewed = connect(mapStateToProps, mapDispatchToProps)(RecentlyViewed);
